import JiraCloudClient from './jiraCloud';
import JiraServerClient from './jiraServer';

const jira = window.__cy_stub_jira_client || (JiraCloudClient.isCloudEnv() ? new JiraCloudClient() : new JiraServerClient());
window.__jira_client = jira;
export default jira;
